import React from "react";
import fetch from "isomorphic-fetch";
import { Grid, Icon, Spinner, Cell, Tabs, Tab } from "react-mdl";

import ItemHelper from "APP/lib/utils";

// Components.
import EquippedItems from "./equipped-items";
import Inventory from "./inventory";
import Stash from "./stash";
import Cube from "./cube";
import Merc from "./merc";
import IronGolem from "./iron-golem";
import GearBonuses from "./gear-bonuses";
import Attributes from "./attributes";
import Skills from "./skills";
import Quest from "./quest";

import "./style.css";

const TabNames = {
  equipped: "#equipped",
  inventory: "#inventory",
  stash: "#stash",
  cube: "#cube",
};

const TabIDs = {
  0: "#equipped",
  1: "#inventory",
  2: "#stash",
  3: "#cube",
};

export default class Character extends React.Component {
  _gearBonuses;
  _attributes;
  _skills;

  state = {
    accountName: null,
    header: null,
    attributes: null,
    skills: null,
    items: null,
    setItems: null,
    mercenary: null,
    golem_item: null,
    is_dead: null,
    last_parsed: null,
    anya_quests: [],
    natural_resistances: [],
    set_bonuses: [],
    error_occurred: false,
    not_found: false,
    download_error: false,
    show_download_button: true,
    active_tab: 0
  };

  constructor(props) {
    super(props);
    this.handleSwitchWeapons = this.handleSwitchWeapons.bind(this);
  }

  componentDidMount() {
    var tab = this.props.location.hash;

    var active = 0;
    switch (tab) {
      case TabNames.equipped:
        active = 0;
        break;
      case TabNames.inventory:
        active = 1;
        break;
      case TabNames.stash:
        active = 2;
        break;
      case TabNames.cube:
        active = 3;
        break;
      default:
        active = 0;
        window.location.hash = TabIDs[0];
        break;
    }


    this.setState({ active_tab: active });

    // Load character data.
    this.loadCharacter();
  }

  downloadSave(event, characterName) {
    event.preventDefault();
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    };
    fetch(
      process.env.API_URL + `/armory/api/armory?character=${characterName}`, requestOptions
    )
      .then((response) => {
        if (response.status === 404) {
          throw new Error("Not found");
        } else if (response.status >= 400) {
          throw new Error("Something went terribly wrong");
        }
        return response.blob();
      }).then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${characterName}.d2s`);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((e) => {
        this.setState({
          download_error: true,
        });
      });
  }

  loadCharacter() {
    fetch(
      process.env.API_URL + `/armory/api/armory?character=${this.props.params.name}`
    )
      .then((response) => {
        if (response.status === 404) {
          throw new Error("Not found");
        } else if (response.status > 404) {
          throw new Error("Something went terribly wrong");
        }
        return response.json();
      })
      .then((response) => {
        if (response.character) {
          let items = {
            equipped: [],
            belt: [],
            inventory: [],
            stash: [],
            cube: [],
          };
          let setItems = {};

          response.character.d2s.items.forEach((item) =>
            ItemHelper.handleItem(item, items, setItems)
          );

          let anyaQuests = [];
          if (response.character.d2s.header.expansion === true) {
            anyaQuests.push(response.character.d2s.header.quests.normal.act_v.quests[2].consumed_scroll);
            anyaQuests.push(response.character.d2s.header.quests.nightmare.act_v.quests[2].consumed_scroll);
            anyaQuests.push(response.character.d2s.header.quests.hell.act_v.quests[2].consumed_scroll);
          }

          let naturalResistances = [0, 0];
          if (response.character.d2s.header.class === 'Barbarian') {
            naturalResistances = response.character.d2s.natural_resistances;
          }

          let setBonuses = [];
          if (response.character.d2s.main_set_bonuses !== undefined) {
            setBonuses.push(response.character.d2s.main_set_bonuses);
          } else {
            setBonuses.push({});
          }
          if (response.character.d2s.secondary_set_bonuses !== undefined) {
            setBonuses.push(response.character.d2s.secondary_set_bonuses);
          } else {
            setBonuses.push({});
          }


          // Make the last played date more readable for every locale.
          var lastPlayedLocale = new Date(
            response.character.d2s.header.last_played
          ).toLocaleString();

          this.setState({
            accountName: response.character.d2s.account_name,
            header: response.character.d2s.header,
            attributes: response.character.d2s.attributes,
            skills: response.character.d2s.skills,
            items: items,
            setItems: setItems,
            mercenary: response.character.d2s.mercenary,
            golem_item: response.character.d2s.golem_item,
            is_dead: response.character.d2s.dead,
            last_parsed: response.character.d2s.last_parsed,
            anya_quests: anyaQuests,
            natural_resistances: naturalResistances,
            set_bonuses: setBonuses,
            error_occurred: false,
            last_played: lastPlayedLocale,
            quests: response.character.d2s.header.quests,
            show_download_button: response.character.d2s.has_unidentified_items === false
          });
        } else {
          this.setState({
            error_occurred: true,
          });
        }
      })
      .catch((e) => {
        if (e.message === "Not found") {
          this.setState({
            not_found: true,
          });
        } else {
          this.setState({
            error_occurred: true,
          });
        }
      });
  }

  determineTab(tabId) {
    this.setState({ active_tab: tabId });
    window.location.hash = TabIDs[tabId];
  }

  handleSwitchWeapons(activeWeaponTabId) {
    this._gearBonuses.handleSwitchWeapons(activeWeaponTabId);
    this._attributes.handleSwitchWeapons(activeWeaponTabId);
    this._skills.handleSwitchWeapons(activeWeaponTabId);
  }

  render() {
    if (this.state.not_found) {
      document.title = "Character not found";
      return (
        <div className="broadcast">
          <Icon name="power" />
          <h1 className="broadcast-text">
            Character does not exist or has not yet entered a game.
          </h1>
        </div>
      );
    }

    if (this.state.error_occurred) {
      document.title = "Parsing error";
      return (
        <div className="broadcast">
          <Icon name="adb" />
          <h1 className="broadcast-text">
            Couldn't parse the character, missing magic attributes probably,
            developers have been notified.
          </h1>
        </div>
      );
    }

    if (!this.state.last_parsed) {
      return (
        <div className="broadcast">
          <Spinner />
          <h1 className="broadcast-text">
            Distorting the space time continuum.
          </h1>
        </div>
      );
    }

    document.title = this.state.header.name;

    if (this.state.is_dead === true) {
      return (
        <div className="broadcast">
          <h1 className="broadcast-text">Dead af.</h1>
        </div>
      );
    }

    return (
      <div>
        <Grid className="menu-grid">
          <Cell col={12} tablet={12} phone={12}>
            <Tabs
              className="tabs-menu"
              activeTab={this.state.active_tab}
              onChange={(tabId) => this.determineTab(tabId)}
              ripple
            >
              <Tab>
                <span className="visible-desktop">Equipped</span>
                <span className="visible-mobile">
                  <Icon name="person" />
                </span>
              </Tab>
              <Tab>
                <span className="visible-desktop">Inventory</span>
                <span className="visible-mobile">
                  <Icon name="room" />
                </span>
              </Tab>
              <Tab>
                <span className="visible-desktop">Stash</span>
                <span className="visible-mobile">
                  <Icon name="home" />
                </span>
              </Tab>
              <Tab>
                <span className="visible-desktop">Cube</span>
                <span className="visible-mobile">
                  <Icon name="crop_square" />
                </span>
              </Tab>
            </Tabs>
          </Cell>
        </Grid>
        <Grid className="character-sheet profile-top">
          <Cell col={6} tablet={12} phone={12}>
            {this.state.accountName !== undefined && (
              <div className="account-name">
                <h4>Account:</h4>
                <a className="acct-name" href={`${process.env.PUBLIC_URL}/account/${this.state.accountName}`}>{this.state.accountName}</a>
              </div>
            )}
            <div className="last-online">
              <h4>Last online:</h4>
              <p>{this.state.last_played}</p>
            </div>
            {this.state.show_download_button === true && (
              <div className="download">
                <h4>Download:</h4>
                <button onClick={evt => this.downloadSave(evt, this.state.header.name)} className='download-button'>download</button>
                {this.state.download_error === true && (
                  <div className="download_error">Error occurred while downloading the file</div>
                )}
              </div>
            )}

          </Cell>
          <Cell col={6} tablet={12} phone={12}>
            <h2 className="char-class">
              ({this.state.header.level}) {this.state.header.class}
            </h2>
            <h1 className="char-name">{this.state.header.title !== null ? this.state.header.title : ''} {this.state.header.name}</h1>
            {this.state.header.expansion === false && (
              <h1 className="char-name classic">Classic</h1>
            )}
            {this.state.header.hardcore === true && (
              <h1 className="char-name hardcore">Hardcore</h1>
            )}
            <h1 className="char-name ladder">Ladder</h1>
            {this.state.header.hardcore === true && this.state.is_dead === true && (
                <h1 className="char-name hc-dead">Dead</h1>
              )}
          </Cell>

          <GearBonuses
            data={{
              equipped: this.state.items.equipped,
              inventory: this.state.items.inventory,
              set_bonuses: this.state.set_bonuses
            }}
            ref={(child) => { this._gearBonuses = child; }}
          />

          {this.state.active_tab === 0 && (
            <EquippedItems
              data={{
                items: this.state.items.equipped,
                setItems: this.state.setItems,
                expansion: this.state.header.expansion,
                set_bonuses: this.state.set_bonuses
              }}
              handleSwitchWeapons={ this.handleSwitchWeapons }
            />
          )}
          { this.state.active_tab === 1 &&
            <Inventory
              data={{
                inventory: this.state.items.inventory,
                setItems: this.state.setItems
              }}
            />
          }
          { this.state.active_tab === 2 &&
            <Stash
              data={{
                stash: this.state.items.stash,
                setItems: this.state.setItems
              }}
            />
          }
          { this.state.active_tab === 3 &&
            <Cube
              data={{
                cube: this.state.items.cube,
                setItems: this.state.setItems
              }}
            />
          }
        </Grid>
        <Grid className="character-sheet profile-low">

          <Attributes
            data={{
              class: this.state.header.class,
              attributes: this.state.attributes,
              equipped: this.state.items.equipped,
              inventory: this.state.items.inventory,
              anya_quests: this.state.anya_quests,
              natural_resistances: this.state.natural_resistances,
              set_bonuses: this.state.set_bonuses,
              expansion: this.state.header.expansion,
            }}
            ref={(child) => { this._attributes = child; }}
          />
          <Skills
            data={{
              skills: this.state.skills,
              expansion: this.state.header.expansion
            }}
            ref={(child) => { this._skills = child; }}
          />
        </Grid>
        {this.state.mercenary !== undefined && (
          <Grid className="character-sheet merc">
            <Merc
              type={this.state.header.merc_type}
              name={this.state.header.merc_name_id}
              level={this.state.header.merc_level}
              data={this.state.mercenary}
            />
          </Grid>
        )}
        {this.state.golem_item !== undefined && (
          <Grid className="character-sheet iron-golem">
            <IronGolem data={this.state.golem_item} />
          </Grid>
        )}
        <Grid className="character-sheet quests">
          <Quest data={{
            quests: this.state.quests,
            expansion: this.state.header.expansion
            }}
          />
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/character/index.js